<template>
  <div class="page">
    <div
      v-for="(element, elementIndex) in pageData"
      v-bind:key="elementIndex"
      class="element"
      v-bind:class="{ full: element.class.indexOf('full') > -1 }"
    >
      <div
        v-bind:class="element.class"
        v-if="element.type == 'info'"
        v-html="element.value"
      ></div>

      <div v-bind:class="element.class" v-if="element.type == 'image'">
        <img v-bind:src="okanMain.imagePrefix + element.value" />
      </div>

      <div v-bind:class="element.class" v-if="element.type == 'question'">
        <input
          v-bind:id="'response_' + element.idPage + '_' + element.id"
          type="text"
          v-model="playerAnswer"
        />
        <div class="answer">
          <div class="passer" @click="skip()"><span>Passer</span></div>
          <div></div>
          <div @click="validate(element)" class="valider">
            <span>Valider</span>
          </div>
        </div>
      </div>

      <div v-bind:class="element.class" v-if="element.type == 'qcm'">
        <div class="buttonsWrapper">
          <div
            v-for="buttonIndex in 4"
            v-bind:key="element.id + '_' + buttonIndex"
            v-html="element.value.split('|')[buttonIndex]"
            class="qcmButton"
            v-bind:class="{ selected: buttonIndex == qcmChoice }"
            @click="qcmChoice = buttonIndex"
          ></div>
          <div class="qcmButton" @click="checkQCM(element)">Valider</div>
        </div>
      </div>

      <div
        class="indice"
        v-if="element.type == 'indice'"
        @click="askForClue(element)"
      >
        <span>I</span>
      </div>

      <div
        v-bind:class="element.class"
        v-if="element.type == 'link'"
        v-html="element.value"
        @click="gotoLink(element.value2)"
      ></div>
    </div>
    <div class="element button">
      <div
        class="button back"
        @click="ChangePage(-1)"
        v-if="!containsQuestion(-1) && okanMain.currentPage > 0"
      ></div>
      <div
        class="button next"
        @click="ChangePage(1)"
        v-if="
          !containsQuestion(1) &&
          okanMain.currentPage < okanMain.pages.length - 1
        "
      ></div>

      <score-board v-bind:okanMain="okanMain" />
    </div>

    <div id="badAnswer" v-show="badAnswer">
      <div class="mainBoard">
        <span>Réponse incorrecte</span>
      </div>
    </div>

    <div id="hasChoice" v-show="hasChoice">
      <div class="mainBoard">
        <span v-html="goodChoice"></span>
      </div>
    </div>
  </div>
</template>

<script>
import scoreBoard from "./scoreboard.vue";

export default {
  name: "page",
  components: {
    scoreBoard,
  },
  props: {
    okanMain: Object,
    pageData: Array,
  },
  data: function () {
    return {
      badAnswer: false,
      playerAnswer: "",
      hasChoice: false,
      goodChoice: "",
      qcmChoice: -1,
    };
  },
  methods: {
    gotoLink(url) {
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display:none";
      a.href = url;
      a.target = "_blank";
      a.click();
      a.remove();
    },
    askForClue(element) {
      this.okanMain.popup = element.value;
      this.okanMain.scoreToAdd -= parseInt(element.value2);
      element.value2 = 0;
    },
    setClue(element) {
      console.log("SetClue", element);
      this.indice = element;
      return true;
    },
    containsClue() {
      if (this.pageData.findIndex((x) => x.type == "indice") >= 0) {
        return true;
      } else {
        this.indice = null;
        return false;
      }
    },
    containsQuestion(index) {
      if (index > 0)
        return (
          this.pageData.findIndex(
            (x) => x.type == "question" || x.type == "qcm"
          ) >= 0
        );
      else
        return (
          this.okanMain.currentPage > 0 &&
          this.okanMain
            .getElements(this.okanMain.pages[this.okanMain.currentPage - 1])
            .findIndex((x) => x.type == "question" || x.type == "qcm") >= 0
        );
    },
    validate(element) {
      var value = document.getElementById(
        "response_" + element.idPage + "_" + element.id
      ).value;
      //console.log("brute", value);
      if (
        this.okanMain.CheckForSpecialChars(
          element,
          this.okanMain.formatResponse(value)
        )
      ) {
        this.okanMain.scoreToAdd += parseInt(element.value2);
        element.value2 = 0;
        this.okanMain.score =
          parseInt(this.okanMain.score) + parseInt(this.okanMain.scoreToAdd);
        this.okanMain.scoreToAdd = 0;
        this.playerAnswer = "";
        this.ChangePage(1);
      } else {
        this.badAnswer = true;
        setTimeout(() => {
          this.badAnswer = false;
        }, 1000);
      }
    },
    skip() {
      if (
        confirm(
          "vous allez perdre les points liés à cette question. Continuer ?"
        )
      ) {
        this.okanMain.scoreToAdd = 0;
        this.playerAnswer = "";
        this.ChangePage(1);
      }
    },
    checkQCM(element) {
      var tableau = element.value.split("|");
      if (this.qcmChoice == -1) {
        this.goodChoice = "Vous devez d'abord choisir une réponse";
        this.hasChoice = true;
        setTimeout(() => {
          this.hasChoice = false;
        }, 1000);
      } else {
        var _time = 2000;
        if (tableau[0] == this.qcmChoice) {
          this.goodChoice = "Bonne réponse";
          _time = 1000;
          this.okanMain.scoreToAdd += parseInt(element.value2);
          this.okanMain.score =
            parseInt(this.okanMain.score) + parseInt(this.okanMain.scoreToAdd);
        } else {
          this.goodChoice =
            "Réponse incorrecte<br/><br/>La bonne réponse était :<br/><br/>" +
            tableau[tableau[0]];
        }
        this.hasChoice = true;
        this.okanMain.scoreToAdd = 0;
        element.value2 = 0;
        this.qcmChoice = -1;
        setTimeout(() => {
          this.ChangePage(1);
          this.hasChoice = false;
        }, _time);
      }
    },
    ChangePage(sens) {
      var pageDiv = document.getElementsByClassName('page')[0];
      pageDiv.scrollTop = 0; 
      if (sens > 0) {
        this.okanMain.currentPage++;
        if (this.okanMain.pages)
          this.okanMain.maxPageReached = Math.max(
            this.okanMain.maxPageReached,
            this.okanMain.currentPage
          );
        if (this.okanMain.currentPage == this.okanMain.pages.length - 1)
          this.okanMain.scoreReduced = false;
      } else {
        this.okanMain.currentPage--;
      }
      this.okanMain.updateCookie();
    },
  },
};
</script>

